import * as React from "react";
import {observable} from "mobx";
import {CrudForm} from "../crud/CrudForm";
import {Input} from "../form/fields/Input";
import {Field} from "../form/Field";
import {PageContent} from "../Layout";
import {Button, Col, Row} from "reactstrap";
import {api} from "../../api";
import {IWindow} from "../../index";
import {enums} from "../../Enums";
import _ = require("lodash");

const IWindow: IWindow = (window as IWindow);

export class ElectionPollingUnitResultDetailFormData {
    @observable id = IWindow.initialState.route.params.id;
    @observable number_of_votes = null;
    @observable candidate_name = null;
    @observable polling_unit_name = null;
    @observable position = null;
    @observable election_name = null;
    @observable party_name = null;
    @observable state_name = null;
    @observable ward_name = null;
    @observable created_by = null;
    @observable created_at = null;
    @observable result_updated = null;
    @observable accredited_voters = null;
    @observable registered_voters = null;
    @observable pu_registered_voters = null;

    @observable user_defined_1 = null;
    @observable user_defined_2 = null;
    @observable disputed_voters = null;
    @observable rejected_voters = null;
    @observable verified_voters_from_cr = null;

    @observable documents = null;
    @observable result_photo = null;
    @observable showDocuments = null;
    @observable check_lists = null;
}

export class ElectionPollingUnitResultDetailForm extends CrudForm {
    modelName = 'ElectionPollingUnitResultDetail';
    icon = '';
    showSubmitButton = false;
	@observable is_admin = IWindow.initialState.user.is_admin;
	@observable permission_polling_unit = IWindow.initialState.permissions.election_polling_unit_result; // .includes["edit"];
	@observable isEdit = this.is_admin ? true : this.permission_polling_unit.includes("edit");

    getData = async () => {
        await api.electionPollingUnitResult.getDetailAction(this.formStore.getValue('id')).then((data: any) => {
            this.formStore.setData(data.data);
            this.formStore.setValue('polling_unit_name', data.data.election_polling_unit.polling_unit.name);
            this.formStore.setValue('candidate_name', data.data.candidate.name);
            this.formStore.setValue('position', data.data.candidate.position.name);
            this.formStore.setValue('election_name', data.data.election.name);
            this.formStore.setValue('party_name', data.data.party.name);
            this.formStore.setValue('state_name', data.data.election_polling_unit.polling_unit.state.name);
            this.formStore.setValue('ward_name', data.data.election_polling_unit.polling_unit.ward.name);
            this.formStore.setValue('lga_name', data.data.election_polling_unit.polling_unit.local_government_area.name);
            this.formStore.setValue('created_by', data.data.created_user.name);
            this.formStore.setValue('registered_voters', data.data.registered_voters);
            this.formStore.setValue('check_lists', data.data.check_lists);
			this.formStore.setValue('result_photo', data.data.result_photo);
            this.entity = data.data;
            if (data.data.accredited_voters) {
                this.formStore.setValue('accredited_voters', data.data.accredited_voters.accredited_voters);
                this.formStore.setValue('pu_registered_voters', data.data.accredited_voters.registered_voters);
                this.formStore.setValue('rejected_voters', data.data.accredited_voters.rejected_voters);
                this.formStore.setValue('disputed_voters', data.data.accredited_voters.disputed_voters);
                this.formStore.setValue('verified_voters_from_cr', data.data.accredited_voters.verified_voters_from_cr);
                this.formStore.setValue('user_defined_1', data.data.accredited_voters.user_defined_1);
                this.formStore.setValue('user_defined_2', data.data.accredited_voters.user_defined_2);
            }
        });
        this.isLoading = false;
    };

    updateResult = async () => {
        this.isLoading = true;
        await api.electionPollingUnitResult.postFormAction(this.formStore.getValue('id'), {
            'number_of_votes': this.formStore.getValue('number_of_votes'),
            'accredited_voters': Number(this.formStore.getValue('accredited_voters')),
            'pu_registered_voters': Number(this.formStore.getValue('pu_registered_voters')),
            'registered_voters': Number(this.formStore.getValue('registered_voters')),
            'disputed_voters': Number(this.formStore.getValue('disputed_voters')),
            'rejected_voters': Number(this.formStore.getValue('rejected_voters')),
            'verified_voters_from_cr': Number(this.formStore.getValue('verified_voters_from_cr')),
            'user_defined_1': Number(this.formStore.getValue('user_defined_1')),
            'user_defined_2': Number(this.formStore.getValue('user_defined_1')),
            'election_polling_unit_id': this.entity.election_polling_unit.id,
            'election_id': this.entity.election_polling_unit.election_id,
        }).then((data: any) => {
            this.formStore.setValue('result_updated', data);
            this.isLoading = false;
            /* setTimeout(window.location.reload(), 2000); */
        });

    };

    renderDocument(document: any) {
        switch (document.file_type) {
            case 'image':
                this.icon = 'icon-image';
                break;

            case 'document':
                this.icon = 'icon-pdf';
                break;

            case 'audio':
                this.icon = 'icon-speaker';
                break;

            case 'video':
                this.icon = 'icon-play-button';
                break;
        }

        return (
            <div className="form-group" key={document.id} data-element={document.id}>
                <a href={document.url} target='_blank'>
                    <span className={this.icon}/> {document.title}
                </a>
            </div>
        );
    };
	
	
	

    renderContent(item: any) {

        if (item.sub_type == 'entry') {
            return this.formStore.data[item.entry_type] ? this.formStore.data[item.entry_type] : '';
        } else if (item.sub_type == 'other' || item.sub_type == 'number' || item.sub_type == 'date' || item.sub_type == 'time'  ) {
            return item.remarks;
        } else if (item.sub_type == 'yes_no') {
            return <div>
                {item.yes_no ? "Yes" : "No"}
                <div>{item.remarks}</div>
            </div>;
        } else if (item.sub_type == 'yes_no') {
            return <div>
                {item.yes_no ? "Yes" : "No"}
                <div>{item.remarks}</div>
            </div>;
        } else if (item.sub_type == 'audio' || item.sub_type == 'document' || item.sub_type == 'video' || item.sub_type == 'image') {
            let document = _.findLast(this.formStore.getValue('documents'), ['check_list_id', item.check_list_id]) || null;
            if (document && document.url) {
                return <a href={document.url} download>Download</a>
            }
            return "";
        }

        return "";
    };

    renderCheckList(item: any) {
        return (
            <tr key={item.check_list_id + 'check-list-id'} data-element={item.id}>
                <td>{item.title}</td>
                <td>{enums.checkListSubType[item.sub_type]}</td>
                <td><span
                    className={"ml-auto " + (item.is_completed ? 'icon-tick' : 'icon-close')}/></td>

                <td>
                    {this.renderContent(item)}
                </td>
            </tr>
        );
    }


    renderFields() {
        return (
            <>
                <Row className="form-row">
                    <Col md={6}>
                        <label
                            className={'font-weight-bold text-primary'}>{this.formStore.getValue('polling_unit_name')}</label>
                    </Col>

                    {/*<Col md={6} className={'d-flex'}>
                        <Field
                            name="number_of_votes"
                            component={Input}
                            required={true}
                            store={this.formStore}
                        />
                        <Button onClick={this.updateResult} type="button" color="primary" className={'mb-3 ml-2'}>
                            Save
                        </Button>
                    </Col>*/}
                </Row>

                <Row className="form-row">
                    <Col md={6}>
                        <Row className="form-row">
                            <Col md={12}>
                                <div className={'form-group'}>
                                    <div className={'font-weight-bold'}>Candidate Name</div>
                                    <div className={'text-primary'}>{this.formStore.getValue('candidate_name')}</div>
                                </div>
                            </Col>
                        </Row>

                        <Row className="form-row">
                            <Col md={12}>
                                <div className={'form-group'}>
                                    <div className={'font-weight-bold'}>Position</div>
                                    <div className={'text-primary'}>{this.formStore.getValue('position')}</div>
                                </div>
                            </Col>
                        </Row>

                        <Row className="form-row">
                            <Col md={12}>
                                <div className={'form-group'}>
                                    <div className={'font-weight-bold'}>Elections</div>
                                    <div className={'text-primary'}>{this.formStore.getValue('election_name')}</div>
                                </div>
                            </Col>
                        </Row>

                        <Row className="form-row">
                            <Col md={12}>
                                <div className={'form-group'}>
                                    <div className={'font-weight-bold'}>Party</div>
                                    <div className={'text-primary'}>{this.formStore.getValue('party_name')}</div>
                                </div>
                            </Col>
                        </Row>

                        <Row className="form-row">
                            <Col md={12}>
                                <div className={'form-group'}>
                                    <div className={'font-weight-bold'}>Polling Unit</div>
                                    <div className={'text-primary'}>{this.formStore.getValue('polling_unit_name')}</div>
                                </div>
                            </Col>
                        </Row>

                        <Row className="form-row">
                            <Col md={12}>
                                <div className={'form-group'}>
                                    <div className={'font-weight-bold'}>Ward</div>
                                    <div className={'text-primary'}>{this.formStore.getValue('ward_name')}</div>
                                </div>
                            </Col>
                        </Row>

                        <Row className="form-row">
                            <Col md={12}>
                                <div className={'form-group'}>
                                    <div className={'font-weight-bold'}>LGA</div>
                                    <div className={'text-primary'}>{this.formStore.getValue('lga_name')}</div>
                                </div>
                            </Col>
                        </Row>

                        <Row className="form-row">
                            <Col md={12}>
                                <div className={'form-group'}>
                                    <div className={'font-weight-bold'}>State</div>
                                    <div className={'text-primary'}>{this.formStore.getValue('state_name')}</div>
                                </div>
                            </Col>
                        </Row>


                        <Row className="form-row">
                            <Col md={12}>
                                <div className={'form-group'}>
                                    <div className={'font-weight-bold'}>Uploaded by</div>
                                    <div className={'text-primary'}>{this.formStore.getValue('created_by')}</div>
                                    <div>{this.formStore.getValue('created_at')}</div>
                                </div>
                            </Col>
                        </Row>
						
						
						 <Row className="form-row">
                            <Col md={12}>
                                <div className={'form-group'}>
                                    <div className={'font-weight-bold'}>EC8A Sheet</div>
                                    <div className={'text-primary'}>
									{
										this.formStore.getValue('result_photo') ? 
										
											 <div className="form-group" key={this.formStore.getValue('result_photo').id} data-element={this.formStore.getValue('result_photo').id}>
                <a href={this.formStore.getValue('result_photo').url} target='_blank'>
                    <span className={this.icon}/> {this.formStore.getValue('result_photo').title}
                </a>
            </div> : ''
										
										
									}	</div>
                                    <div></div>
                                </div>
                            </Col>
                        </Row>
						
						
                    </Col>

                    <Col md={6}>
                        <div className={'font-weight-bold form-group'}>Uploaded files</div>
                        {
                            this.formStore.getValue('documents').map((document: any) => {
                                return this.renderDocument(document);
                            })
                        }
                    </Col>
					
					{/* <Col md={6}>
                        <div className={'font-weight-bold form-group'}>Suspected</div>
                       <span className={'text-primary'}> {this.formStore.getValue('registered_voters') < this.formStore.getValue('pu_registered_voters') ? 'YES' :   this.formStore.getValue('pu_registered_voters') <= this.formStore.getValue('accredited_voters') ? 'YES' : this.formStore.getValue('accredited_voters') < this.formStore.getValue('number_of_votes') ? 'YES' : 'NO'     } </span>
                    </Col> */ }
					
					
                </Row>
                <Row className="form-row mt-4">

                    <Col md={2}>
                        <div className={'form-group'}>
                            <div className={'font-weight-bold'}>INEC Registered Voters</div>
                            <div className={'text-primary'}>{this.formStore.getValue('registered_voters')}
							
							</div>
                        </div>
                    </Col>

                    <Col md={2}>
                        <div className={'form-group'}>
                            <div className={'font-weight-bold'}>Number of Votes</div>
                            <Field
							    disabled={this.isEdit ? false : true}
                                name="number_of_votes"
                                component={Input}
                                required={true}
                                store={this.formStore}
                            />
                        </div>
                    </Col>

                    <Col md={2}>
                        <div className={'form-group'}>
                            <div className={'font-weight-bold'}>Accredited Voters</div>
                            <Field
							 disabled={this.isEdit ? false : true}
                                name="accredited_voters"
                                component={Input}
                                required={true}
                                store={this.formStore}
                            />
                        </div>
                    </Col>

                    <Col md={2}>
                        <div className={'form-group'}>
                            <div className={'font-weight-bold'}>Reg. Voters on BVAS</div>
                            <Field
							 disabled={this.isEdit ? false : true}
                                name="pu_registered_voters"
                                component={Input}
                                required={true}
                                store={this.formStore}
                            />
                        </div>
                    </Col>

                    <Col md={2}>
                        <div className={'form-group'}>
                            <div className={'font-weight-bold'}>Disputed Votes</div>
                            <Field
							 disabled={this.isEdit ? false : true}
                                name="disputed_voters"
                                component={Input}
                                required={true}
                                store={this.formStore}
                            />
                        </div>
                    </Col>

                    <Col md={2}>
                        <div className={'form-group'}>
                            <div className={'font-weight-bold'}>Rejected Votes</div>
                            <Field
							 disabled={this.isEdit ? false : true}
                                name="rejected_voters"
                                component={Input}
                                required={true}
                                store={this.formStore}
                            />
                        </div>
                    </Col>
                </Row>
                <Row className="form-row">
                    {
                        this.formStore.getValue('result_updated') ?
                            <Col md={12}>
                                <div className="alert alert-success alert-dismissible fade show" role="alert">
                                    <button type="button" className="close" data-dismiss="alert" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                    Result updated successfully!
                                </div>
                            </Col>
                            : ''
                    }
                    <Col md={12}>
                        <Button onClick={this.updateResult} disabled={this.isEdit ? false : true} type="button" color="primary" className={'mb-3 ml-2'}>
                            Update
                        </Button>
                    </Col>

                </Row>

                {this.formStore.getValue('check_lists') ? <br/> : ''}
                {this.formStore.getValue('check_lists') ?
                    <div className="d-flex flex-column">
                        <div className="card dashboard-card box-shadow border-0 rounded-0 flex-grow-1">
                            <div className="card-body py-0 d-flex flex-column">
                                <div className="row">
                                    <div className="col-xl-12 dash-sep-xl-right">
                                        <h6 className="light-subheading text-center text-uppercase my-3">Check
                                            Lists</h6>
                                        <div className="table-responsive">
                                            <table className="grid table table-hover">
                                                <thead>
                                                <tr>
                                                    <th>Title</th>
                                                    <th>Type</th>
                                                    <th>Is Completed</th>
                                                    <th>Content</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                {
                                                    this.formStore.getValue('check_lists').map((checkList: any) => {
                                                        return this.renderCheckList(checkList);
                                                    })
                                                }
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> : ''}
            </>
        );
    }
}

export class ElectionPollingUnitResultDetailPage extends React.Component {
    modelName = 'ElectionPollingUnitResultDetail';

    constructor(props: any) {
        super(props);
    }

    render() {
        return (
            <>
                <PageContent>
                    <ElectionPollingUnitResultDetailForm/>
                </PageContent>
            </>
        );
    }
}



// WEBPACK FOOTER //
// ./resources/js/components/pages/ElectionPollingUnitResultDetailPage.tsx